module.exports = __webpack_public_path__ + "static/media/css1.0fc9d143.png";